module.exports = __webpack_public_path__ + "public/Icons/nextArrowIcon.svg?83ded3e0";